import script from "./ServerWebPressurePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerWebPressurePanel.vue?vue&type=script&setup=true&lang=js"

import "./ServerWebPressurePanel.vue?vue&type=style&index=0&id=ff4bf574&lang=scss"

const __exports__ = script;

export default __exports__